module.exports = __webpack_public_path__ + "img/home_top1.42765315.png";